module.exports = __webpack_public_path__ + "static/media/stevenchen.fc0f9824.jpeg";